import React from 'react';

import SinglePostHelper from '../../compos/SinglePostHelper/SinglePostHelper';
import '../News/News.css';

function SinglePost() {
	return (
		<div className='News'>
			<SinglePostHelper />
		</div>
	);
}

export default SinglePost;
